(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dyca-before-after"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-ba-slider]').forEach(initSlider);

    function initSlider(slider) {
      const after = slider.querySelector('.dyca-ba__img--after');
      const handle = slider.querySelector('.dyca-ba__handle');
      const handleBtn = slider.querySelector('[data-ba-handle]');
      const range = slider.querySelector('[data-ba-range]');
      if (!after || !handle || !handleBtn) return;

      const startPos = parseFloat(slider.dataset.startPosition) || 50;
      let dragging = false;

      const setPosition = (pct) => {
        pct = Math.max(0, Math.min(100, pct));
        after.style.clipPath = `inset(0 0 0 ${pct}%)`;
        handle.style.left = pct + '%';
        if (range) range.value = pct;
      };

      const getPctFromEvent = (e) => {
        const rect = slider.getBoundingClientRect();
        const x = e.touches ? e.touches[0].clientX : e.clientX;
        return ((x - rect.left) / rect.width) * 100;
      };

      setPosition(startPos);

      const onStart = (e) => {
        dragging = true;
        // Prevent text selection & image drag while dragging
        if (e.cancelable && e.type === 'mousedown') e.preventDefault();
      };

      const onMove = (e) => {
        if (!dragging) return;
        setPosition(getPctFromEvent(e));
        // Only block page scroll while actively dragging the handle
        if (e.cancelable) e.preventDefault();
      };

      const onEnd = () => {
        dragging = false;
      };

      // Only the handle button starts a drag — taps on the image do nothing
      handleBtn.addEventListener('mousedown', onStart);
      handleBtn.addEventListener('touchstart', onStart, { passive: true });

      window.addEventListener('mousemove', onMove);
      window.addEventListener('touchmove', onMove, { passive: false });
      window.addEventListener('mouseup', onEnd);
      window.addEventListener('touchend', onEnd);
      window.addEventListener('touchcancel', onEnd);

      // Keyboard accessibility via the hidden range input
      if (range) {
        range.addEventListener('input', (e) => {
          setPosition(parseFloat(e.target.value));
        });
      }

      // Arrow-key support directly on the handle button
      handleBtn.addEventListener('keydown', (e) => {
        const current = parseFloat(range ? range.value : 50);
        let next = current;
        if (e.key === 'ArrowLeft') next = current - 2;
        else if (e.key === 'ArrowRight') next = current + 2;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = 100;
        else return;
        e.preventDefault();
        setPosition(next);
      });

      // Block the default image drag-ghost on desktop
      slider.querySelectorAll('img').forEach((img) => {
        img.addEventListener('dragstart', (e) => e.preventDefault());
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dyca-faq"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-faq-item]').forEach(item => {
      const btn = item.querySelector('.dyca-faq__btn');
      if (!btn) return;
      btn.addEventListener('click', () => {
        const isOpen = item.classList.toggle('open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dyca-pdp"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const section = document.currentScript ? document.currentScript.closest('.dyca-pdp') : null;
    const sections = document.querySelectorAll('.dyca-pdp');

    sections.forEach(initPdp);

    function initPdp(pdp) {
      const variantsScript = pdp.querySelector('[data-variants-json]');
      if (!variantsScript) return;

      let variants = [];
      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch (e) {
        console.error('DYCA PDP: invalid variants JSON', e);
        return;
      }

      const variantIdInput = pdp.querySelector('[data-variant-id]');
      const priceEl = pdp.querySelector('[data-price]');
      const compareEl = pdp.querySelector('[data-compare-price]');
      const saveEl = pdp.querySelector('[data-save]');
      const atcBtn = pdp.querySelector('[data-atc-btn]');
      const atcLabel = pdp.querySelector('[data-atc-label]');
      const atcPrice = pdp.querySelector('[data-atc-price]');
      const qtyInput = pdp.querySelector('[data-qty-input]');
      const qtyMinus = pdp.querySelector('[data-qty-minus]');
      const qtyPlus = pdp.querySelector('[data-qty-plus]');

      // Track currently selected options
      const selectedOptions = [];
      pdp.querySelectorAll('[data-option-index]').forEach(group => {
        const index = parseInt(group.dataset.optionIndex, 10);
        const activeBtn = group.querySelector('[data-option-value].active');
        if (activeBtn) selectedOptions[index] = activeBtn.dataset.value;
      });

      // Option selection
      pdp.querySelectorAll('[data-option-value]').forEach(btn => {
        btn.addEventListener('click', () => {
          const index = parseInt(btn.dataset.optionIndex, 10);
          const value = btn.dataset.value;

          // Update active state in the same option group
          pdp.querySelectorAll(`[data-option-index="${index}"] [data-option-value]`).forEach(b => {
            b.classList.remove('active');
          });
          btn.classList.add('active');

          // Update selected label
          const labelEl = pdp.querySelector(`[data-selected-value="${index}"]`);
          if (labelEl) labelEl.textContent = value;

          selectedOptions[index] = value;
          updateVariant();
        });
      });

      function updateVariant() {
        const matched = variants.find(v =>
          selectedOptions.every((opt, i) => v.options[i] === opt)
        );

        if (!matched) {
          setSoldOut();
          return;
        }

        // Update hidden variant ID
        if (variantIdInput) variantIdInput.value = matched.id;

        // Update price
        if (priceEl) priceEl.textContent = formatMoney(matched.price);

        if (compareEl) {
          if (matched.compare_at_price && matched.compare_at_price > matched.price) {
            compareEl.textContent = formatMoney(matched.compare_at_price);
            compareEl.hidden = false;
            if (saveEl) {
              saveEl.textContent = 'Save ' + formatMoney(matched.compare_at_price - matched.price);
              saveEl.hidden = false;
            }
          } else {
            compareEl.hidden = true;
            if (saveEl) saveEl.hidden = true;
          }
        }

        // Update ATC button state
        if (atcBtn) {
          if (matched.available) {
            atcBtn.disabled = false;
            if (atcLabel && atcPrice) {
              atcPrice.textContent = '— ' + formatMoney(matched.price);
            } else if (atcLabel) {
              atcLabel.innerHTML = 'Add to Cart <span class="dyca-pdp__atc-price">— ' + formatMoney(matched.price) + '</span>';
            }
          } else {
            atcBtn.disabled = true;
            if (atcLabel) atcLabel.textContent = 'Sold Out';
          }
        }

        // Update URL with variant query param
        if (history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', matched.id);
          history.replaceState({}, '', url.toString());
        }
      }

      function setSoldOut() {
        if (atcBtn) {
          atcBtn.disabled = true;
          if (atcLabel) atcLabel.textContent = 'Unavailable';
        }
      }

      function formatMoney(cents) {
        // Use Shopify's money format if available via global
        if (window.Shopify && window.Shopify.formatMoney) {
          const format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
          return window.Shopify.formatMoney(cents, format);
        }
        // Fallback: simple EUR formatting (matches source HTML style)
        const value = (cents / 100).toFixed(2).replace('.', ',');
        return '€' + value;
      }

      // Quantity
      if (qtyMinus && qtyInput) {
        qtyMinus.addEventListener('click', () => {
          const v = parseInt(qtyInput.value, 10) || 1;
          if (v > 1) qtyInput.value = v - 1;
        });
      }
      if (qtyPlus && qtyInput) {
        qtyPlus.addEventListener('click', () => {
          const v = parseInt(qtyInput.value, 10) || 1;
          qtyInput.value = v + 1;
        });
      }

      // Gallery thumbs
      const mainImg = pdp.querySelector('[data-main-image] .dyca-pdp__main-img-el');
      pdp.querySelectorAll('[data-thumb]').forEach(thumb => {
        thumb.addEventListener('click', () => {
          pdp.querySelectorAll('[data-thumb]').forEach(t => t.classList.remove('active'));
          thumb.classList.add('active');
          const full = thumb.dataset.fullImage;
          if (mainImg && full) {
            if (mainImg.tagName === 'IMG') {
              mainImg.src = full;
              mainImg.srcset = '';
            }
          }
        });
      });

      // Accordions
      pdp.querySelectorAll('.dyca-pdp__acc-btn').forEach(btn => {
        btn.addEventListener('click', () => {
          const item = btn.closest('.dyca-pdp__acc-item');
          const isOpen = item.classList.toggle('open');
          btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
